import { LEAGUES_NAV } from '../../data/leaguesNavData.js';

export function leagueImageSrc(imageKey) {
    return `/images/league_${imageKey}.png`;
}

/**
 * @param {string} activeLeagueId
 * @returns {string}
 */
export function buildLeagueSelectorHTML(activeLeagueId) {
    return `
        <div class="league-selector" data-league-selector role="toolbar" aria-label="Choose league">
            ${LEAGUES_NAV.map(
                (lg) => `
                <button type="button"
                    class="league-selector__item${lg.id === activeLeagueId ? ' league-selector__item--active' : ''}"
                    data-league-id="${lg.id}"
                    aria-pressed="${lg.id === activeLeagueId ? 'true' : 'false'}"
                    title="${lg.title}">
                    <span class="league-selector__img-wrap">
                        <img class="league-selector__img" src="${leagueImageSrc(lg.imageKey)}" alt="" loading="lazy" data-fallback-text="${lg.label}">
                        <span class="league-selector__fallback" hidden>${lg.label.charAt(0)}</span>
                    </span>
                    <span class="league-selector__label">${lg.label}</span>
                </button>
            `
            ).join('')}
        </div>
    `;
}

/**
 * @param {HTMLElement} root
 * @param {(leagueId: string) => void} onSelect
 */
export function attachLeagueSelectorListeners(root, onSelect) {
    root.querySelectorAll('[data-league-selector] [data-league-id]').forEach((btn) => {
        btn.addEventListener('click', () => {
            const id = btn.getAttribute('data-league-id');
            if (id) onSelect(id);
        });
        const img = btn.querySelector('.league-selector__img');
        const fb = btn.querySelector('.league-selector__fallback');
        if (img && fb) {
            img.addEventListener('error', () => {
                img.style.display = 'none';
                fb.hidden = false;
            });
        }
    });
}

/**
 * @param {HTMLElement} root
 * @param {string} activeLeagueId
 */
export function updateLeagueSelectorActive(root, activeLeagueId) {
    root.querySelectorAll('[data-league-selector] [data-league-id]').forEach((btn) => {
        const id = btn.getAttribute('data-league-id');
        const active = id === activeLeagueId;
        btn.classList.toggle('league-selector__item--active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
}
